'use client';

import PostThumb, { PostThumbProps } from '@/components/_blog-updates/PostThumb';
import { PostThumbCropped } from '@/components/PostThumbCropped';
import '@/styles/libs/swiper-article-footer.css';
import '@/styles/libs/swiper-blog.css';
import { FC } from 'react';
import 'swiper/css';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export type PostThumbCarouselProps = {
  theme?: 'light' | 'dark' | 'white';
  items?: PostThumbProps[]
  cropThumbImages?: boolean;
  onAssetClick?: (mediaItemId: string) => void;
}

const PostThumbCarousel: FC<PostThumbCarouselProps> = ({
  theme = 'light',
  items = [],
  cropThumbImages = false,
  onAssetClick,
}) => {

  return (
    <div className="w-full">
      <Swiper
        className='swiper-blog swiper-article-footer'
        modules={[Navigation]}
        spaceBetween={16}
        navigation
        slidesPerView={1}
        loop={false}
        breakpoints={{
          960: {
            spaceBetween: 32,
            slidesPerView: 3
          },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            {cropThumbImages ? (
              <PostThumbCropped
                theme={theme}
                {...item}
                onAssetClick={onAssetClick}
              />
            ) : (
              <PostThumb
                {...item}
                theme={theme}
                onAssetClick={onAssetClick}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PostThumbCarousel;
